import React, { Component } from "react";
import { withRouter } from "react-router";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import Button from "components/CustomButtons/Button.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import Datetime from "react-datetime";
import NotifList from "granular/Notification/notifList.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CardAvatar from "components/Card/CardAvatar.jsx";
import { withStyles } from "@material-ui/core/styles";
import { pushLoader } from "../../actions/main";
import { connect } from "react-redux";

import {
  fetchCompanyAll,
  pushCompany,
  updateCompany,
  deleteCompany,
  proccessUpload
} from "../../api/company";

import moment from "moment";
import CompanyList from "../../granular/Company/companyList";
import Config from "../../config/";
const ROOT_URL = Config.rooturl;

const styles = theme => ({
  title: {
    textAlign: "center",
    flex: 1,
    fontSize: "32px",
    fontWeight: 500
  }
});

class Company extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      company_name: "",
      company_address: "",
      company_telp: "",
      company_code: "",
      company_limit: "",
      company_email: "",
      company_img: "-",
      datatable: [],
      openAdd: false,
      openEdit: false,
      picture_url: "",
      file_upload: "",
      msg_imgerr: "",
      msg_err: "",
      loader: null
    };
  }

  componentDidMount() {
    this.getDatatable();
  }

  restate = args => {
    this.setState({
      id: args[0],
      company_name: args[1],
      company_address: args[6],
      company_telp: args[4],
      company_code: args[2],
      company_limit: args[3],
      company_email: args[5],
      company_img: `${ROOT_URL}${args[7]}`,
      openEdit: true
    });
    // this.updating()
  };

  updating = () => {
    // let picture_url = "";

    // proccessUpload(this.state.file_upload)
    //   .then(response => {
    //     picture_url = response.data.url;
    //     console.log(picture_url);
    //     picture_url = response.data.url;
    //     this.setState({ company_img: picture_url });
    updateCompany(this.state)
      .then(response => {
        if (response != null) {
          this.getDatatable();
          this.setState({
            company_name: "",
            company_address: "",
            company_telp: "",
            company_code: "",
            company_limit: "",
            company_email: "",
            company_img: "",
            openEdit: false
          });
        }
        this.setState({ msg_err: "" });
      })

      .catch(error => {
        this.setState({
          msg_err: "please fill all field above correctly!"
        });
        console.log("tidak berhasil");
        //this.props.history.push("/pages/login#logout");
      });
    // })
    // .catch(error => {
    //   console.log("tidak berhasil");
    //   this.props.history.push("/pages/login#logout");
    // });
  };

  getDatatable = () => {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    fetchCompanyAll()
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        //this.props.pushToken(error);
        //this.props.history.push("/pages/login#logout");
      });
  };

  handleChangeText = (keys, e) => {
    this.setState({ [keys]: e.target.value });
  };

  handleDelete = id => {
    deleteCompany(id)
      .then(response => {
        if (response != null) {
          this.getDatatable();
        }
      })
      .catch(error => {
        console.log("tidak berhasil");
        //this.props.history.push("/pages/login#logout");
      });
  };

  handleSubmit = () => {
    // let picture_url;

    // if (this.state.file_upload !== "") {
    //   this.setState({ msg_imgerr: "" });
    //   proccessUpload(this.state.file_upload)
    //     .then(response => {
    //       picture_url = response.data.url;
    //       this.setState({ company_img: picture_url });
    //       console.log(picture_url);
    pushCompany(this.state)
      .then(response => {
        if (response != null) {
          this.getDatatable();
          this.setState({
            company_name: "",
            company_address: "",
            company_telp: "",
            company_code: "",
            company_limit: "",
            company_email: "",
            openAdd: false,
            company_img: ""
          });
        }
        this.setState({ msg_err: "" });
      })
      .catch(e => {
        //console.log(e);
        this.setState({
          msg_err: "please fill all field above correctly!"
        });
        // console.log("tidak berhasil");
        //this.props.history.push("/pages/login#logout");
      });
    //     })
    //     .catch(error => {
    //       console.log("tidak berhasil");
    //       this.props.history.push("/pages/login#logout");
    //     });
    // } else {
    //   console.log("tidak berhasil");
    //   this.setState({ msg_imgerr: "Please upload company logo" });
    // }
  };

  handleClose = (key, value) => {
    if (key === "openAdd") {
      this.setState({
        company_name: "",
        company_address: "",
        company_telp: "",
        company_code: "",
        company_limit: "",
        company_email: "",
        openAdd: false,
        company_img: ""
      });
    }
    this.setState({
      [key]: value
    });
  };

  handleFileUpload = event => {
    this.setState({ file_upload: event.target.files[0] });
    console.log(event.target.files[0]);
  };

  renderAddCompany = () => {
    if (localStorage.getItem("userlevel") === "2") {
      return (
        <CardHeader color="rose" icon>
          <Button
            color="behance"
            round
            onClick={() => this.handleClose("openAdd", true)}
          >
            Add Company
          </Button>
        </CardHeader>
      );
    } else {
      return <div />;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ justifyContent: "center" }}>
            <Typography className={classes.title}>Company Group</Typography>
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="info"
              value={100}
              style={{ width: "20%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            {this.renderAddCompany()}
            <CompanyList
              datatable={this.state.datatable}
              handleDelete={this.handleDelete}
              restate={this.restate}
              loader={this.state.loader}
            />
          </Card>
          <Dialog
            fullScreen
            open={this.state.openAdd}
            onClose={() => this.handleClose("openAdd", false)}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Add Company Group</DialogTitle>
            <DialogContent>
              <GridContainer>
                {/* <GridItem xs={12} sm={12} md={12}>
                  <Card profile>
                    <CardBody profile>
                      <title>Logo</title>

                      <Button variant="contained" component="label">
                        <CustomInput
                          inputProps={{
                            type: "file",
                            onChange: this.handleFileUpload
                          }}
                        />
                      </Button>
                    </CardBody>
                    <font color="red">{this.state.msg_imgerr}</font>
                  </Card>
                </GridItem> */}
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Company Group Name"
                    id="headerText"
                    inputProps={{
                      value: this.state.company_name,
                      onChange: e => this.handleChangeText("company_name", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                  <font color="red">{this.state.msg_errcompname}</font>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Phone Number"
                    id="company_telp"
                    inputProps={{
                      value: this.state.company_telp,
                      onChange: e => this.handleChangeText("company_telp", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                  <font color="red">{this.state.msg_errphonenum}</font>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Company Code"
                    id="company_code"
                    inputProps={{
                      value: this.state.company_code,
                      onChange: e => this.handleChangeText("company_code", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                  <font color="red">{this.state.msg_errcompcode}</font>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="User Limit"
                    id="company_limit"
                    inputProps={{
                      type: "number",
                      value: this.state.company_limit,
                      onChange: e => this.handleChangeText("company_limit", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                  <font color="red">{this.state.mgs_erruserlimit}</font>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Email"
                    id="company_email"
                    inputProps={{
                      value: this.state.company_email,
                      onChange: e => this.handleChangeText("company_email", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                  <font color="red">{this.state.msg_erremail}</font>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Address"
                    id="company_address"
                    inputProps={{
                      value: this.state.company_address,
                      onChange: e => this.handleChangeText("company_address", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                  <font color="red">{this.state.msg_erraddress}</font>
                </GridItem>
              </GridContainer>
              <font color="red">{this.state.msg_err}</font>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => this.handleClose("openAdd", false)}
                color="default"
                round
              >
                Cancel
              </Button>
              <Button onClick={() => this.handleSubmit()} color="success" round>
                Save
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            fullScreen
            open={this.state.openEdit}
            onClose={() => this.handleClose("openEdit", false)}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Update Company</DialogTitle>
            <DialogContent>
              <GridContainer>
                {/* <GridItem xs={12} sm={12} md={12}>
                  <Card profile>
                    <CardBody profile>
                      <title>Logo</title>
                      <CardAvatar>
                        <a href="#pablo" onClick={e => e.preventDefault()}>
                          <img
                            height="100px"
                            src={this.state.company_img}
                            alt="..."
                          />
                        </a>
                      </CardAvatar>
                      <Button variant="contained" component="label">
                        <CustomInput
                          inputProps={{
                            type: "file",
                            onChange: this.handleFileUpload
                          }}
                        />
                      </Button>
                    </CardBody>
                  </Card>
                </GridItem> */}
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Company Name"
                    id="headerText"
                    inputProps={{
                      value: this.state.company_name,
                      onChange: e => this.handleChangeText("company_name", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Phone Number"
                    id="company_telp"
                    inputProps={{
                      value: this.state.company_telp,
                      onChange: e => this.handleChangeText("company_telp", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Company Code"
                    id="company_code"
                    inputProps={{
                      value: this.state.company_code,
                      onChange: e => this.handleChangeText("company_code", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="User Limit"
                    id="company_limit"
                    inputProps={{
                      type: "number",
                      value: this.state.company_limit,
                      onChange: e => this.handleChangeText("company_limit", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Email"
                    id="company_email"
                    inputProps={{
                      value: this.state.company_email,
                      onChange: e => this.handleChangeText("company_email", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Address"
                    id="company_address"
                    inputProps={{
                      value: this.state.company_address,
                      onChange: e => this.handleChangeText("company_address", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
              </GridContainer>
              <font color="red">{this.state.msg_err}</font>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => this.handleClose("openEdit", false)}
                color="default"
                round
              >
                Cancel
              </Button>
              <Button onClick={() => this.updating()} color="success" round>
                Update
              </Button>
            </DialogActions>
          </Dialog>
        </GridItem>
      </GridContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    //blocking: state.loader
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    { pushLoader }
  )(withStyles(styles)(Company))
);
